/**
 * Test IDs for QA automation.
 */
export const testIds = {
  groupFormName: "group-form-name",
  groupFormDefaultFromReceiverForOrders: "group-form-default-from-receiver-for-orders",
  groupFormSave: "group-form-save",
} as const;
